"use no memo";

import {
  type Cell,
  flexRender,
  type Renderable,
  type Row,
  type Table,
} from "@tanstack/react-table";
import type { CSSProperties } from "react";
import { useRef } from "react";

import type { TokenBalanceSummary } from "@/graphql/codegen/graphql";

type TableParams = {
  id: string;
  column: { columnDef: { cell: Renderable<object> } };
  getContext: () => { row: { id: string }; column: { id: string } };
};

export const TableItem = ({
  data: { table, tableRows, renderLoader, columnsWidth },
  index,
  style,
}: {
  data: {
    table: Table<TableParams>;
    tableRows: Row<TokenBalanceSummary>[];
    renderLoader: () => React.ReactNode;
    columnsWidth: number[];
  };
  index: number;
  style: CSSProperties;
}) => {
  const rowRef = useRef<null | HTMLDivElement>(null);

  const rowModel = tableRows?.[index];

  if (!rowModel) return null;

  const rows = table.getRowModel()?.rows;
  const row = rows?.[index];

  return (
    <div key={row.id} style={style}>
      <div ref={rowRef} className="flex w-full items-stretch border-b">
        {row.getVisibleCells().map(
          (
            cell: Cell<
              {
                id: string;
                column: { columnDef: { cell: Renderable<object> } };
                getContext: () => {
                  row: { id: string };
                  column: { id: string };
                };
              },
              unknown
            >,
            idx,
          ) => (
            <div
              className="relative flex items-center p-2"
              key={cell.id}
              style={{ width: `${columnsWidth[idx]}%` }}
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </div>
          ),
        )}
      </div>

      {row.id === tableRows[tableRows.length - 1].id && renderLoader()}
    </div>
  );
};
